import DayRail from "./DayRail";
import WeekRail from "./WeekRail";

export default function StickyStackedNav({
  weeks,
  selectedWeekNumber,
  onSelectWeek,
  workouts,
  selectedWorkoutOrderIndex,
  onSelectWorkout,
}) {
  return (
    <nav className="lz-product-sticky-stacked-nav" aria-label="Cycle navigation">
      <WeekRail
        weeks={weeks}
        selectedWeekNumber={selectedWeekNumber}
        onSelect={onSelectWeek}
      />
      <DayRail
        workouts={workouts}
        selectedWorkoutOrderIndex={selectedWorkoutOrderIndex}
        onSelect={onSelectWorkout}
      />
    </nav>
  );
}
